function Contact() {
  return (
    <section>Contact</section>
  )
}

export default Contact